import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function NavBar() {
  const { user, logout, isVolunteer, isAdmin, isRealAdmin, isPreviewing, previewRole, setPreviewRole } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';
  // The portal has sub-pages, so highlight it for any /volunteer/* route.
  const isSectionActive = (prefix) =>
    location.pathname.startsWith(prefix) ? 'nav-link active' : 'nav-link';

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={() => setMobileOpen(false)}>🥾 LCPOA Trails</Link>
      </div>

      <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
        {mobileOpen ? '✕' : '☰'}
      </button>

      <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
        <Link to="/" className={isActive('/')} onClick={() => setMobileOpen(false)}>Map</Link>
        {isVolunteer && (
          <Link to="/segments" className={isActive('/segments')} onClick={() => setMobileOpen(false)}>Segments</Link>
        )}
        {isVolunteer && (
          <Link to="/volunteer" className={isSectionActive('/volunteer')} onClick={() => setMobileOpen(false)}>Volunteers</Link>
        )}
        {isAdmin && (
          <Link to="/admin" className={isActive('/admin')} onClick={() => setMobileOpen(false)}>Admin</Link>
        )}
      </div>

      {user && (
        <div className="navbar-user">
          {/* Preview mode indicator + toggle for real admins */}
          {isRealAdmin && (
            <div className="preview-toggle">
              {isPreviewing && (
                <span className="preview-badge">Viewing as: {previewRole}</span>
              )}
              <select
                value={previewRole || 'admin'}
                onChange={(e) => setPreviewRole(e.target.value === 'admin' ? null : e.target.value)}
                className="preview-select"
              >
                <option value="admin">Admin View</option>
                <option value="volunteer">Preview as Volunteer</option>
                <option value="neighbor">Preview as Neighbor</option>
              </select>
            </div>
          )}
          {user.avatar_url && <img src={user.avatar_url} alt="" className="user-avatar" />}
          <span className="user-name">{user.display_name}</span>
          <button onClick={logout} className="btn-logout">Logout</button>
        </div>
      )}
    </nav>
  );
}
